import React from "react";

/**
 * Badge environnement discret — DEV seulement (BT-GSD-KARATE-AUTH-SHELL-001).
 */
export function GsdDemoModeBanner({ mode = "production", testId = "gsd-demo-mode-banner" }) {
  if (mode === "production") return null;
  return (
    <div className="gsd-demo-banner gsd-demo-banner--env-only" data-testid={testId}>
      <span className="gsd-env-badge" data-testid="gsd-env-badge">
        DEV
      </span>
    </div>
  );
}
